export default __webpack_public_path__ + "static/media/location-track-phone.83b5f8b5.svg";